module.exports = __webpack_public_path__ + "media/img/referrals/product-7b702f81a4e5dcd55a93bccff6ac06fc.png";